import React from "react";
import { Link } from "react-router-dom";
import Image from "../../../components/image/Image";
import "./BredcomTitle.scss";

const BredcomTitle = (props) => {
  return (
    <React.Fragment>
      {props.pageTitle || props.titleImg ? (
        <div className="bredcom-section">
          <div className="left-big-title">
            {props.titleImg ? (
              <Image imagePath={props.titleImg} altText="Title Image" />
            ) : null}
            <div className="title-text">{props.pageTitle}</div>
          </div>
          <div className="breadcrumb-path">
            <Link to={"/"}>Dashboard</Link>
            <span className="dot-middle">/</span>
            <span>{props.pageTitle}</span>
          </div>
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default BredcomTitle;
